import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import BaoModal from '../components/ui/BaoModal';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const content = (
    <div>
      {/* Header */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginBottom: "12px",
        }}
      >
        <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-red-100">
          <svg
            className="h-6 w-6 text-red-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div>

        {/* Title */}
        <h2
          style={{
            fontSize: "24px",
            fontWeight: 600,
            fontFamily: "Bricolage Grotesque",
            margin: 0,
          }}
        >
          Access Denied
        </h2>

        {/* Description */}
        <p
          style={{
            fontSize: "13px",
            fontWeight: 400,
            fontFamily: "Poppins, sans-serif",
            margin: "0 0 8px 0",
          }}
        >
          You don't have permission to access this page.
        </p>

        {/* Alert Box */}
        <div
          style={{
            backgroundColor: "#FEF2F2",
            border: "1px solid #FEE2E2",
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "24px",
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ flexShrink: 0 }}>
              <svg
                style={{
                  width: "20px",
                  height: "20px",
                }}
                className="text-red-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div style={{ marginLeft: "12px" }}>
              <h3
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "Poppins, sans-serif",
                  margin: "0 0 8px 0",
                }}
              >
                Unauthorized Access
              </h3>
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: 400,
                  fontFamily: "Poppins, sans-serif",
                  margin: 0,
                }}
              >
                <p>
                  This page requires administrative privileges. If you believe this is an error, please contact your system administrator.
                </p>
                {location.state?.from && typeof location.state.from === 'string' && (
                  <p style={{ marginTop: "8px" }}>
                    <strong>Attempted to access:</strong> {location.state.from}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ marginBottom: "8px" }}>
          <Link to="/">
            <button
              type="button"
              className="inline-flex items-center justify-center gap-2"
              style={{
                backgroundColor: "rgb(26, 26, 26)",
                color: "rgb(255, 255, 255)",
                borderWidth: "medium",
                borderStyle: "none",
                borderColor: "currentcolor",
                borderImage: "initial",
                borderRadius: "8px",
                padding: "14px 19px",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
                fontFamily: "Poppins, sans-serif",
                width: "100%"
              }}
            >
              Back to Home
            </button>
          </Link>
        </div>

        {/* Help Link */}
        <div style={{ paddingTop: "8px" }}>
          <p
            style={{
              fontSize: "13px",
              fontWeight: 400,
              fontFamily: "Poppins, sans-serif",
              margin: 0,
            }}
          >
            Need help?{' '}
            <Link
              to="/contact-support"
              className="font-medium text-orange-600 hover:text-orange-500"
            >
              Contact Support
            </Link>
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <BaoModal
        isOpen={true}
        onClose={() => navigate('/dashboard')}
        closeOnEsc={false}
        closeOnBackdropClick={false}
        backdropClassName="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm"
        panelClassName="relative w-full max-w-md mx-4 overflow-hidden rounded-[30px] p-0 bg-white"
      >
        <div className="p-6">
          {content}
        </div>
      </BaoModal>
    </div>
  );
};

export default Unauthorized;
